// pool/use-pool.jsx — the pool model for the panel, live.
//
// Everything on the page is plain entities in hass.states except the
// week of water temperatures, which comes from recorder statistics only
// while the page is open, refreshed hourly.

import * as React from 'react';
import { readPool, WATER } from './model.js';

const REFRESH_MS = 60 * 60 * 1000;
export const TREND_DAYS = 8;

export function usePool(hass, now) {
  const states = hass?.states;
  // `now` ticks once a minute in the app; the Stop steps need finer time,
  // so the page passes its own clock while a step is in flight.
  return React.useMemo(() => readPool(states, now || new Date()), [states, now]);
}

// [{ start, mean }] daily means of the settled temperature, or null while loading.
export function usePoolTemps(hass, enabled) {
  const conn = hass?.connection;
  const [rows, setRows] = React.useState(null);
  React.useEffect(() => {
    if (!enabled || !conn?.sendMessagePromise) return undefined;
    let cancelled = false;
    const load = () => {
      const start = new Date(); start.setHours(0, 0, 0, 0);
      start.setDate(start.getDate() - (TREND_DAYS - 1));
      conn.sendMessagePromise({
        type: 'recorder/statistics_during_period',
        start_time: start.toISOString(),
        statistic_ids: [WATER.temp],
        period: 'day',
        types: ['mean'],
      }).then((r) => { if (!cancelled) setRows(r?.[WATER.temp] || []); })
        .catch(() => { if (!cancelled) setRows([]); });
    };
    load();
    const t = setInterval(load, REFRESH_MS);
    return () => { cancelled = true; clearInterval(t); };
  }, [conn, enabled]);
  return rows;
}
